module.exports = __webpack_public_path__ + "static/media/Aymeric-profile.ea6de6b9.jpg";